module.exports = __webpack_public_path__ + "media/images/vp/parallax.temp.03-5db03125ebfce23897806d865d4061dc.svg";